import { COLORS, LEVELS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';
import { CONTENT_EDITION_BAR_HEIGHT } from 'Components/structural/SContentEditionBar/SContentEditionBar.style';

export const VIDEO_WIDTH = '532';
export const VIDEO_HEIGHT = '296';

export default createStyleSheet({
  container: {
    display: 'flex',
    position: 'relative',
  },
  editionBar: {
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: LEVELS.CONTENT_EDITION_BAR,
    minWidth: 1024,
    borderBottom: `1px solid ${COLORS.GREY_MEDIUM.DEFAULT}`,
  },
  contributorsModal: {
    width: 550,
    minHeight: 200,
    maxHeight: 456,
    overflow: 'auto',
  },
  disabledOverlay: {
    position: 'absolute',
    zIndex: LEVELS.CONTENT_DISABLED_FORM_LAYER,
    backgroundColor: 'rgba(34, 42, 52, 0.25)',
  },
  disabledCallout: {
    zIndex: LEVELS.CONTENT_EDITION_CALLOUT,
  },
});
